import type { UserPromptMessage } from '@/entities/discovery';
import { UserMessageBubble } from './primitives';

export const UserMessagePrompt = ({ message }: { message: UserPromptMessage }) => {
  return (
    <UserMessageBubble>
      <p className="text-muted text-sm">{message.content.message}</p>
    </UserMessageBubble>
  );
};
